import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BugIcon = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path d="M16 5C14.7143 6.5 12.5714 8 10 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M16 16C15.2472 15.2612 14.2227 14.5223 13 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4 16C4.75282 15.2612 5.77734 14.5223 7 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4 5C5.28571 6.5 7.42857 8 10 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28378 7.17188C5.57403 7.99519 5.1449 9.06725 5.1449 10.2395V11.0942C5.1449 13.6903 7.24945 15.7949 9.84554 15.7949C12.4416 15.7949 14.5462 13.6903 14.5462 11.0942V10.2396C14.5462 9.06727 14.1171 7.99523 13.4073 7.17192C12.8589 7.34328 12.2506 7.47618 11.6003 7.56237C12.4712 8.13434 13.0462 9.11979 13.0462 10.2396V11.0942C13.0462 12.8619 11.6132 14.2949 9.84554 14.2949C8.07787 14.2949 6.6449 12.8619 6.6449 11.0942V10.2395C6.6449 9.11978 7.21994 8.13432 8.09082 7.56235C7.44045 7.47616 6.8322 7.34324 6.28378 7.17188Z"
        fill={color}
      />
      <mask id="path-6-inside-1_10645_34021" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.31259 5.5682C7.03998 5.46568 6.85461 5.20989 6.85461 4.91865C6.85461 3.03058 8.19387 1.5 9.84593 1.5C11.498 1.5 12.8372 3.03058 12.8372 4.91865C12.8372 5.11092 12.7261 5.28471 12.5532 5.36884C11.7621 5.75375 10.7733 5.98242 9.70062 5.98242C8.82881 5.98242 8.01244 5.83139 7.31259 5.5682Z"
        />
      </mask>
      <path
        d="M12.5532 5.36884L11.8969 4.02003L12.5532 5.36884ZM7.31259 5.5682L6.7846 6.9722L7.31259 5.5682ZM8.35461 4.91865C8.35461 3.6646 9.20418 3 9.84593 3V0C7.18357 1.19209e-07 5.35461 2.39656 5.35461 4.91865H8.35461ZM9.84593 3C10.4877 3 11.3372 3.6646 11.3372 4.91865H14.3372C14.3372 2.39656 12.5083 -1.19209e-07 9.84593 0V3ZM11.8969 4.02003C11.3294 4.29616 10.5682 4.48242 9.70062 4.48242V7.48242C10.9785 7.48242 12.1949 7.21133 13.2095 6.71764L11.8969 4.02003ZM9.70062 4.48242C8.99832 4.48242 8.36179 4.3602 7.84057 4.1642L6.7846 6.9722C7.66309 7.30257 8.6593 7.48242 9.70062 7.48242V4.48242ZM11.3372 4.91865C11.3372 4.5238 11.5656 4.18125 11.8969 4.02003L13.2095 6.71764C13.8866 6.38817 14.3372 5.69804 14.3372 4.91865H11.3372ZM5.35461 4.91865C5.35461 5.86421 5.95537 6.66037 6.7846 6.9722L7.84057 4.1642C8.12459 4.271 8.35461 4.55558 8.35461 4.91865H5.35461Z"
        fill={color}
        mask="url(#path-6-inside-1_10645_34021)"
      />
      <path d="M2.5 11H5.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14 11H17" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
})

export default BugIcon
